export const EventTypeInfo = {
  custom: {
    key: "custom",
    label: "Custom",
    textColor: "black",
    backendLabel: "manual",
  },
  recommended: {
    key: "recommended",
    label: "Recommended",
    textColor: "white",
    backendLabel: "recommendation",
  },
  block: {
    key: "block",
    label: "Blocked",
    textColor: "black",
    backendLabel: "block",
  },
  deleted: {
    key: "deleted",
    label: "Deleted",
    textColor: "black",
    backendLabel: "deleted",
  },
  default: {
    key: "default",
    label: "Default",
    textColor: "black",
    backendLabel: "default",
  },
  approved: {
    key: "approved",
    label: "Applied",
    textColor: "white",
    backendLabel: "approved",
  },
  auto_resize: {
    key: "auto_resize",
    label: "Auto Resize",
    textColor: "white",
    backendLabel: "auto_resize",
  },
  backoff: {
    key: "backoff",
    label: "Backoff",
    textColor: "white",
    backendLabel: "backoff",
  },
};

export const LEGEND_ITEMS = [
  { label: "Recommended", color: "#E9F2FF" },
  { label: "Recommended & Applied", color: "#247EFE" },
  { label: "Custom", color: "#FFEBE5" },
  { label: "Custom & Scheduled", color: "#E38E00" },
  { label: "Expired", color: "#8390A3" },
  { label: "Blocked", color: "#FEE8E7" },
] as const;

export enum ScheduleStatus {
  Pending = "pending",
  Approved = "approved",
  Rejected = "rejected",
}

export const WarehouseScheduleOpportunity = "warehouse_schedule_recommendation";

export const WarehouseScheduleRecurrenceEndDate = "2100-01-01T00:00:00.000Z";

// A recurring series is bounded: its end date may be at most this many days
// after the start. Mirrors the backend `MAX_SERIES_DAYS`.
export const MAX_SERIES_DAYS = 90;

// Lowercase values match the backend `days_of_week` contract; the short label
// renders on toggles and summaries, the full name is the accessible name.
// Array order is week order, so filtering against it also sorts day sets.
export const DAYS_OF_WEEK = [
  { value: "monday", label: "Monday", short: "Mon" },
  { value: "tuesday", label: "Tuesday", short: "Tue" },
  { value: "wednesday", label: "Wednesday", short: "Wed" },
  { value: "thursday", label: "Thursday", short: "Thu" },
  { value: "friday", label: "Friday", short: "Fri" },
  { value: "saturday", label: "Saturday", short: "Sat" },
  { value: "sunday", label: "Sunday", short: "Sun" },
];

export const GET_SCHEDULED_OPPORTUNITY_DATA = "GET_SCHEDULED_OPPORTUNITY_DATA";
